import React from "react";
import { BaseIcon, BaseIconProps, BaseSVGIconProps } from "./BaseIcon";

const SvgPlayIconIcon = ({
  color,
  alt,
  "aria-roledescription":
    roleDescription = "File icon with play symbol in the center",
  ...restProps
}: BaseSVGIconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <title>{alt}</title>
    {roleDescription ? <desc>{roleDescription}</desc> : null}
    <g clipPath="url(#clip0_24662_258378)">
      <path
        d="M15.625 17.5H4.375C4.20924 17.5 4.05027 17.4342 3.93306 17.3169C3.81585 17.1997 3.75 17.0408 3.75 16.875V3.125C3.75 2.95924 3.81585 2.80027 3.93306 2.68306C4.05027 2.56585 4.20924 2.5 4.375 2.5H11.875L16.25 6.875V16.875C16.25 17.0408 16.1842 17.1997 16.0669 17.3169C15.9497 17.4342 15.7908 17.5 15.625 17.5Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.875 2.5V6.875H16.25"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip1_24662_258378)">
        <path
          d="M7.73438 8.66836V13.8316C7.73514 13.8728 7.74676 13.9131 7.76805 13.9484C7.78934 13.9837 7.81956 14.0127 7.85566 14.0326C7.89176 14.0525 7.93246 14.0625 7.97366 14.0616C8.01486 14.0607 8.05511 14.049 8.09033 14.0276L12.3114 11.446C12.3451 11.4256 12.373 11.3968 12.3924 11.3625C12.4117 11.3282 12.4219 11.2894 12.4219 11.25C12.4219 11.2106 12.4117 11.1718 12.3924 11.1375C12.373 11.1032 12.3451 11.0744 12.3114 11.054L8.09033 8.47237C8.05511 8.45098 8.01486 8.43926 7.97366 8.43839C7.93246 8.43752 7.89176 8.44753 7.85566 8.4674C7.81956 8.48728 7.78934 8.51632 7.76805 8.55161C7.74676 8.58689 7.73514 8.62716 7.73438 8.66836Z"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_24662_258378">
        <rect
          width="20"
          height="20"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_24662_258378">
        <rect
          width="7.5"
          height="7.5"
          fill="white"
          transform="translate(5.625 7.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

const PlayIconIcon = (props: BaseIconProps) => (
  <BaseIcon {...props}>
    <SvgPlayIconIcon />
  </BaseIcon>
);

export default PlayIconIcon;
